import { getAddendum } from "actions/RFQ/addendumAction";
import { AddendumClient } from "components/Pages/RFQDetail/AddendumClient";
import { useRfxData } from "newui/features/Rfx/data-provider/RfxDataProvider";
import { Addendum } from "pages/RFQSubmission/addendum/Addendum.types";
import { useEffect, useState, forwardRef } from "react";

type ClientAddendumContainerProps = {
	isCommunication: boolean;
};

export const ClientAddendumContainer = forwardRef<
	HTMLDivElement,
	ClientAddendumContainerProps
>(({ isCommunication = false }, ref) => {
	const { rfxData, hasRfxLoaded, rfxTabTotals, setRfxTabTotals } = useRfxData();
	const [addendums, setAddendums] = useState<Addendum[]>([]);
	const [isLoading, setIsLoading] = useState<boolean>(false);

	const onAddendumsUpdated = (addendums) => {
		setAddendums(addendums);
		const newCount =
			(addendums?.length ?? 0) +
			(isCommunication ? rfxTabTotals.comms : rfxTabTotals.addendums);
		setRfxTabTotals({
			...rfxTabTotals,
			addendums: isCommunication ? rfxTabTotals.addendums : newCount,
			comms: isCommunication ? newCount : rfxTabTotals.comms,
		});
	};

	const rfxId = rfxData?.id;

	useEffect(() => {
		if (!rfxId) {
			return;
		}

		let cancelled = false;
		setIsLoading(true);
		getAddendum(rfxId, isCommunication ? "unpublished" : "published")
			.then((res) => {
				if (cancelled) {
					return;
				}
				setAddendums(res?.data);
			})
			.finally(() => {
				if (!cancelled) {
					setIsLoading(false);
				}
			});

		return () => {
			cancelled = true;
		};
	}, [rfxId, isCommunication]);

	return (
		<div ref={ref}>
			{
				// @ts-ignore
				<AddendumClient
					rfqDetail={rfxData}
					addendumData={addendums}
					setAddendumData={onAddendumsUpdated}
					isCommunication={isCommunication}
					isDataLoading={isLoading || !hasRfxLoaded}
				/>
			}
		</div>
	);
});

ClientAddendumContainer.displayName = "ClientAddendumContainer";